import { FREE_TRIAL_FORM_NAME_REDIRECT, FREE_TRIAL_FORM_NAME_SHOW_NUMBER } from './core/free-trial-submission';
const initFreeTrialForm = (freeTrialForm) => {
    const companyNameInput = freeTrialForm.querySelector('input[name="account_name"]');
    const greetingInput = freeTrialForm.querySelector('input[name="greeting_c"]');
    const greetingDisplay = freeTrialForm.querySelector('input[name="greeting_c"] ~ .display-option ');
    if (!companyNameInput || !greetingInput || !greetingDisplay) {
        return;
    }
    const greetingOptions = greetingInput.parentElement?.querySelectorAll('ul.select-options li');
    const replacePlaceholders = (text) => {
        const companyNamePlaceholder = text.match(/\[([^\]]+)\]/);
        const companyName = companyNameInput.value ||
            (companyNamePlaceholder && companyNamePlaceholder.length == 2 ? companyNamePlaceholder[1] : '');
        return text
            .replace(/\[([^\]]+)\]/, '<span class="placeholder-value">' + companyName + '</span>')
            .replace(/\{([^\}]+)\}/, '<span class="placeholder">$1</span>');
    };
    greetingOptions.forEach((greetingOption) => {
        greetingOption.dataset.original = greetingOption.innerText;
    });
    const updateGreetingOptions = () => {
        greetingOptions.forEach((greetingOption) => {
            greetingOption.innerHTML = replacePlaceholders(greetingOption.dataset.original || '');
            if (greetingOption.classList.contains('active')) {
                greetingDisplay.innerHTML = greetingOption.innerHTML;
            }
        });
    };
    companyNameInput.addEventListener('keyup', updateGreetingOptions);
    companyNameInput.addEventListener('change', updateGreetingOptions);
    updateGreetingOptions();
    freeTrialForm.dataset.formName =
        freeTrialForm.querySelectorAll('.free-trial-number').length > 0
            ? FREE_TRIAL_FORM_NAME_SHOW_NUMBER
            : FREE_TRIAL_FORM_NAME_REDIRECT;
};
export const initFreeTrials = () => {
    const init = () => {
        const freeTrialForms = document.querySelectorAll('.free-trial-form.advanced-select-form');
        freeTrialForms.forEach((freeTrialForm) => initFreeTrialForm(freeTrialForm));
    };
    document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
};
